
module dg.objects {
    import DG_DATA_TYPES = dg.restfulApi.DG_DATA_TYPES;
    import DG_PROPERTY_TYPES = dg.restfulApi.PropertyType;
    import DG_LINK_RELS = dg.restfulApi.DG_LINK_RELS;

    export interface IPropertyEditorScope extends ng.IScope {
        propertyId: string;
        propMeta: dg.restfulApi.DomainObjectPropertyMetadata;
        domainObject: dg.domain.IDomainObject;
        form: ng.IFormController;
    }

    function propertyEditor(
        $compile,
        $parse: ng.IParseService,
        $filter: dgUtils.IFilterService): ng.IDirective {
        return {
            restrict: 'A',
            priority: 900,
            terminal: true,
            scope: {
                propertyId: '<propertyEditor'
            },
            require: ['^objectEditor'],
            templateUrl: '/digmo/src/objects/properties/property-editor.html',
            replace: true,
            link: (scope: IPropertyEditorScope, instanceElement: ng.IAugmentedJQuery, instanceAttributes: ng.IAttributes, controllers, transclude: ng.ITranscludeFunction) => {

                let objectEditorController: ObjectEditorController = controllers[0];

                objectEditorController.OnValueChanged(newValue => {
                    scope.domainObject = newValue;
                    scope.propMeta = newValue.dgMeta.properties[scope.propertyId];
                });

                let watchDestroy = scope.$watch('propertyId', (propName: string) => {

                    scope.propMeta = objectEditorController.properties[propName];

                    if (!scope.propMeta) {
                        throw Error(`Property ${propName} is missing`);
                    }

                    watchDestroy();

                    scope.form = objectEditorController.form;

                    let element: any = null;
                    let propValue = null;

                    //directive recompilation


                    if (scope.propMeta.propertyType == "ChildObject") {

                        //instanceElement.attr('dg-child-object', '');
                        //instanceElement.removeAttr('dg-form-control');
                    } else if (scope.propMeta.propertyType == "Reference") {
                        //link
                        //if (scope.propMeta.readOnly) {
                        //    element = angular.element('<lookup-read-only />');
                        //} else {
                        //element = angular.element('<lookup />');
                        element = angular.element('<nya-select />');
                        //}

                        if (scope.propMeta.tagging) {
                            element = angular.element('<lookup />');
                            element.attr('tagging', '');
                        }

                        if (scope.propMeta.multiple) {
                            element = angular.element('<lookup />');
                            element.attr('multiple', '');
                        }

                    } else {
                        //scalar
                        if (scope.propMeta.dataType == DG_DATA_TYPES.Date
                            || scope.propMeta.dataType == DG_DATA_TYPES.DateTime) {
                            element = angular.element('<datepicker-popup />')

                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.MultilineText) {
                            element = angular.element('<div/>');
                            element.attr('multiline-text', '');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.RichText) {
                            element.attr('wysiwyg', '');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.ExternalFile) {
                            if (!propValue.hasFile) {
                                //add action delayers if file upload is allowed
                                //var invokeLinks = $filter('dgLinksByRel')(scope.dgMeta.links, DG_LINK_RELS.invoke);

                                //TODO:Verify that delayers are not used
                                //var actionDelayer = scope.registerActionDelayes(invokeLinks);
                                //propElement.attr('dg-file-upload-defer', 'actionDelayers[\'' + actionDelayer.id + '\']');
                            }
                            //  propElement.attr('dg-file-prop', propExpression);

                            //HACK: expect to have fileTypeId property
                            //   propElement.attr('file-type-id', '{{' + dgDomainTypeMeta.domainObjectName + '.fileTypeId}}');
                            //HACK: expect to have fileName property
                            //   propElement.attr('file-name', '{{' + dgDomainTypeMeta.domainObjectName + '.fileName}}');
                            //instanceElement.removeAttr('dg-form-control');
                        }
                        else if (scope.propMeta.dataType == DG_DATA_TYPES.BlobFile) {
                            element = angular.element('<file-upload />');
                        }
                        //else if (scope.propMeta.dataType == DG_DATA_TYPES.base64File) {
                        //    element = angular.element('<base64-file/>');
                        //}
                        else if (scope.propMeta.dataType == DG_DATA_TYPES.Period) {
                            element = angular.element("<period readonly=" + scope.propMeta.readOnly + " />");
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.DateRange || scope.propMeta.dataType == DG_DATA_TYPES.MonthRange) {
                            element = angular.element('<custom-date-range />');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.Bool) {
                            element = angular.element('<div/>');
                            element.attr('bool', '');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.Amount) {
                            element = angular.element('<div/>');
                            element.attr('amount', '');
                        } else if (scope.propMeta.dataType == DG_DATA_TYPES.Percent) {
                            element = angular.element('<div/>');
                            element.attr('percent', '');
                        } else {
                            element = angular.element('<div/>');
                            element.attr('text', '');
                        }
                    }


                    var prop = "domainObject." + scope.propMeta.id;

                    element.attr('id', scope.propMeta.id);
                    element.attr('name', scope.propMeta.id);
                    
                    element.attr('ng-model', prop);
                    element.attr('prop-meta', 'propMeta');

                    if (scope.propMeta.extensions) {
                        for (let extName in scope.propMeta.extensions) {
                            element.attr($filter('camelToDashes')(extName) + '-extension', 'propMeta.extensions.' + extName);
                        }
                    }

                    //custom directive recompilation
                    element.removeAttr('property-editor');
                    element.removeAttr('ng-repeat');

                    instanceElement.prepend(element);
                    instanceElement.removeAttr('property-editor');
                    instanceElement.removeAttr('ng-repeat');
                    $compile(element)(scope);

                });
            }
        };
    }

    angular.module('dg.objects')
        .directive('propertyEditor', propertyEditor);
}